export { default } from './CheckElement';



// WEBPACK FOOTER //
// ./src/components/atoms/CheckElement/index.js